import React from 'react';
import { MapPin, Mail, Phone, ArrowRight } from 'lucide-react';

const Footer = () => {
  const launchCities = [
  { name: 'Tampa', state: 'FL', status: 'Active', phase: 'Phase 1' },
  { name: 'Orlando', state: 'FL', status: 'Q2 2024', phase: 'Phase 2' },
  { name: 'Phoenix', state: 'AZ', status: 'Q3 2024', phase: 'Phase 3' },
  { name: 'Dallas', state: 'TX', status: 'Q4 2024', phase: 'Phase 4' }];


  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0">
        <div className="absolute top-20 left-20 w-32 h-32 bg-primary/10 rounded-full blur-2xl"></div>
        <div className="absolute bottom-20 right-20 w-24 h-24 bg-orange-500/10 rounded-full blur-xl"></div>
      </div>
      <div className="relative z-10">
        {/* Main Footer Content */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-12">
            
            {/* Company Info */}
            <div className="lg:col-span-2">
              <div className="mb-8">
                <div className="flex items-center mb-4">
                  <img
                    src="/assets/images/Untitled_design_2_-1761185899832.png"
                    alt="Unified ProConnect logo featuring blue house icon with orange clock element on the left, followed by PROCONNECT text where PRO is in blue and CONNECT is in black, with EMERGENCY HOME SERVICES tagline underneath in gray text"
                    className="h-12 w-auto object-contain" />

                </div>
                <p className="text-gray-300 leading-relaxed max-w-md">
                  The exclusive professional services platform launching across the Sun Belt. 
                  Join our founding members for lifetime benefits and priority access.
                </p>
              </div>

              {/* Contact Info */}
              <div className="space-y-4">
                <div className="flex items-center gap-3 text-gray-300">
                  <MapPin className="w-5 h-5 text-orange-400 flex-shrink-0" />
                  <span>Launching in Tampa, FL • Expanding to 4 states</span>
                </div>
                <div className="flex items-center gap-3 text-gray-300">
                  <Mail className="w-5 h-5 text-orange-400 flex-shrink-0" />
                  <span>Support@proconnect247.com</span>
                </div>
                <div className="flex items-center gap-3 text-gray-300">
                  <Phone className="w-5 h-5 text-orange-400 flex-shrink-0" />
                  <span>(813) 537-6058</span>
                </div>
              </div>
            </div>

            {/* Launch Cities */}
            <div>
              <h4 className="text-xl font-bold text-white mb-8">Launch Cities</h4>
              <div className="space-y-4">
                {launchCities?.map((city, index) =>
                <div key={index} className="flex items-center justify-between py-2">
                    <div>
                      <div className="text-white font-medium">{city?.name}, {city?.state}</div>
                      <div className="text-sm text-gray-400">{city?.phase}</div>
                    </div>
                    <div className={`text-sm font-semibold px-3 py-1 rounded-full ${
                  city?.status === 'Active' ? 'bg-green-500/20 text-green-400' : 'bg-orange-500/20 text-orange-400'}`
                  }>
                      {city?.status}
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Founding Member Benefits */}
            <div>
              <h4 className="text-xl font-bold text-white mb-8">Founding Benefits</h4>
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-orange-400 rounded-full mt-2 flex-shrink-0"></div>
                  <div>
                    <div className="text-white font-medium">$50 Service Credit</div>
                    <div className="text-sm text-gray-400">On your first booking</div>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-orange-400 rounded-full mt-2 flex-shrink-0"></div>
                  <div>
                    <div className="text-white font-medium">Lifetime App Access</div>
                    <div className="text-sm text-gray-400">No booking fees ever</div>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-orange-400 rounded-full mt-2 flex-shrink-0"></div>
                  <div>
                    <div className="text-white font-medium">Priority Service</div>
                    <div className="text-sm text-gray-400">Skip the line</div>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-orange-400 rounded-full mt-2 flex-shrink-0"></div>
                  <div>
                    <div className="text-white font-medium">Wall of Founders</div>
                    <div className="text-sm text-gray-400">Optional recognition</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Final CTA Section */}
        <div className="border-t border-gray-700/50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div className="flex flex-col md:flex-row items-center justify-between gap-8">
              <div>
                <h4 className="text-2xl font-bold text-white mb-2">
                  Ready to Join the Founding Members?
                </h4>
                <p className="text-gray-300">
                  Limited to 1,000 members • Exclusive lifetime benefits • Tampa launch priority
                </p>
              </div>
              
              <button
                className="group bg-gradient-to-r from-orange-500 to-orange-600 text-white font-bold text-lg px-8 py-4 rounded-2xl hover:from-orange-600 hover:to-orange-700 transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap"
                onClick={() => document.getElementById('waitlist-section')?.scrollIntoView({ behavior: 'smooth' })}>

                <span className="flex items-center gap-3">
                  Join Waitlist Now
                  <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
                </span>
              </button>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-700/50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-gray-400 text-sm">
              <div>
                © 2024 ProConnect. All rights reserved. • Founding Members Program Limited to First 1,000.
              </div>
              <div className="flex items-center gap-6">
                <a href="#" className="hover:text-orange-400 transition-colors duration-200">Privacy Policy</a>
                <a href="#" className="hover:text-orange-400 transition-colors duration-200">Terms of Service</a>
                <a href="#" className="hover:text-orange-400 transition-colors duration-200">Contact</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>);

};

export default Footer;